export default __webpack_public_path__ + "static/media/pdf.d6cd42d7.svg";